// EmployeeEditor.jsx

import React, { useEffect, useState } from "react";
import { Col, Container, Row, Card, CardBody } from "reactstrap";
import Stepper from "react-stepper-horizontal";
import { useParams } from "react-router";
import { useFormik } from "formik";
import months from "../data/months";
import MonthlyReportServices from "../../../../services/COOPServices/MonthlyReportServices/MonthlyReportServices";
import ReportTypeServices from "../../../../services/COOPServices/ReportTypeServies/ReportTypeServices";
import SubHeadingServices from "../../../../services/COOPServices/SubHeadingServices/SubHeadingServices";
import CustomInput from "../../../../Components/Common/CustomInput/CustomInput";
import CustomSelect from "../../../../Components/Common/CustomSelect/CustomSelect";
import Breadcrumbs from "../../../../Components/Common/BreadCrumbs";
import steps from "../data/steps";
import TableComponent from "../components/TableComponent";
import DraftButtons from "../Button/DraftButtons";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import LanguageToggle from "../LanguageToggleButton/LanguageToggle";
import ReportPDF from "../ReportPDF/ReportPdf";
import { pdf } from "@react-pdf/renderer";

const DraftReport = () => {
  const [headings, setHeadings] = useState();
  const [reportTypeOption, setReportTypeOption] = useState();
  const [report, setReport] = useState();
  console.log("🚀 ~ DraftReport ~ report:", report);
  const { id } = useParams();
  const [isVisible, setIsVisible] = useState(false);
  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: report?.reportName || "",
      reportTypeId:
        {
          label: report?.reportType.name,
          value: report?.reportType.id,
        } || "",
      year:
        {
          label: report?.year,
          value: report?.year,
        } || "",
      // `reportTxns.${index}.reportSubTxnDtos.${i}.subTxnDtos.${subindex}.subHeadingId`
      month: months.filter((item) => item.value === report?.month)[0] || "",
      reportTxns:
        report?.mainHeadings.map((reportTxn) => {
          return {
            reportSubTxnDtos: reportTxn?.reportTxns?.map((item) => {
              return {
                reportTxnId: item.reportTxnId,
                subTxnDtos: item.reportSubTxnDtos?.map((subItem) => {
                  return {
                    reportSubTxnId: subItem.reportSubTxnId,
                    subHeadingId: subItem.subHeadingId,
                    credit: subItem.credit,
                    debit: subItem.debit,
                  };
                }),
              };
            }),
          };
        }) ||
        [
          // {
          //   reportSubTxnDtos: [
          //     {
          //       subHeadingId: 0,
          //       credit: 0,
          //       debit: 0,
          //     },
          //   ],
          // },
        ],
    },
    onSubmit: async (values) => {
      const formattedData = {
        // ...values,
        reportId: +id,
        reportName: formik.values.name,
        reportTypeId: values.reportTypeId?.value,
        year: values.year?.value,
        month: values.month?.value,
        reportTxns: values?.reportTxns?.map((reportTxn) => {
          return {
            reportSubTxnDtos: reportTxn?.reportSubTxnDtos?.map((item) => {
              console.log(
                "🚀 ~ reportSubTxnDtos:reportTxn?.reportSubTxnDtos?.map ~ item:",
                item
              );
              return {
                reportTxnId: item.reportTxnId,
                updateSubTxnDtos: item.subTxnDtos.map((subItem) => {
                  return {
                    reportSubTxnId: subItem.reportSubTxnId,
                    subHeadingId: subItem.subHeadingId,
                    credit: subItem.credit,
                    debit: subItem.debit,
                  };
                }),
              };
            }),
          };
        }),
      };
      try {
        const response = await MonthlyReportServices.submit({
          id: id,
          data: formattedData,
        });
        toast.success("Report Initiated Successf ully!");
        fetchReport();
        // navigate(`/initiated-report/${id}`);
      } catch (error) {
        console.log("🚀 ~ handleInitiateReport ~ error:", error);
      }
    },
  });

  const fetchReportTypeOption = async () => {
    try {
      const response = await ReportTypeServices.getList({
        pageNumber: 1,
        pageSize: 100,
      });
      const temp = response?.data?.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
      setReportTypeOption(temp);
    } catch (error) {
      console.log("🚀 ~ fetchReportTypeOption ~ error:", error);
    }
  };

  const fetchheadings = async () => {
    try {
      const response = await SubHeadingServices.getDisplayList();

      setHeadings(response);
    } catch (error) {
      console.log("🚀 ~ fetchheadings ~ error:", error);
    }
  };

  const fetchReport = async () => {
    try {
      const response = await MonthlyReportServices.getDetail({ reportId: id });
      setReport(response);
    } catch (error) {
      console.log("🚀 ~ fetchReport ~ error:", error);
    }
  };

  useEffect(() => {
    fetchReportTypeOption();
    fetchheadings();
    fetchReport();
  }, [id]);

  const breadcrumbItems = [
    { title: "Reports", link: "/report" },
    { title: "Create New Report" },
  ];

  const handleSaveDraft = async () => {
    try {
      const response = await MonthlyReportServices.draft({
        id: id,
        data: {
          ...formik.values,
          reportId: id,
          reportName: formik.values.name,
          reportTypeId: formik.values.reportTypeId?.value,
          year: formik.values.year?.value,
          month: formik.values.month?.value,
          reportTxns: formik.values?.reportTxns?.map((reportTxn) => {
            return {
              reportTxnId: reportTxn.reportTxnId,
              reportSubTxnDtos: reportTxn?.reportSubTxnDtos?.map((item) => {
                return {
                  updateSubTxnDtos: item.subTxnDtos.map((subItem) => {
                    return {
                      reportSubTxnId: subItem.reportSubTxnId,
                      subHeadingId: subItem.subHeadingId,
                      credit: subItem.credit,
                      debit: subItem.debit,
                    };
                  }),
                };
              }),
            };
          }),
        },
      });
      toast.success("Draft Saved Successfully!");
      fetchReport();
    } catch (error) {
      console.log("🚀 ~ handleSaveDraft ~ error:", error);
    }
  };

  const handleGenerate = async () => {
    try {
      const pdfBlob = await pdf(<ReportPDF id={id} />).toBlob();
      const url = URL.createObjectURL(pdfBlob);
      window.open(url);
    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Failed to generate PDF.");
    }
  };

  console.log("formik.values", formik.values);
  console.log("formik.errors", formik.errors);

  return (
    <React.Fragment>
      <form onSubmit={formik.handleSubmit}>
        <Container fluid>
          <div className="page-content">
            <Row>
              <Col>
                <Row className="justify-content-between ">
                  <Col>
                    <Breadcrumbs items={breadcrumbItems} />
                  </Col>
                  <Col className="text-end">
                    <button
                      style={{
                        border: "none",
                        marginRight: "15px",
                        padding: "0",
                      }}
                    >
                      <LanguageToggle
                        toggleVisibility={toggleVisibility}
                        setIsVisible={setIsVisible}
                        isVisible={isVisible}
                      />
                    </button>
                  </Col>
                </Row>
                <Row>
                  <DraftButtons
                    // heading={
                    //   isVisible ? item?.headingNepName : item?.headingEngName
                    // }
                    // subHeadingGroups={
                    //   isVisible
                    //     ? item?.subHeadingGroups.subitem.subheadingNepName
                    //     : item?.subHeadingGroups.subitem.subheadingEngName
                    // }
                    // index={index}
                    handleSaveDraft={handleSaveDraft}
                    status={report?.reportStatus}
                    isVisible={isVisible}
                    toggleVisibility={toggleVisibility}
                    resetForm={formik.resetForm}
                    formik={formik}
                    handleGenerate={handleGenerate}
                  />
                </Row>
                <Row className="px-2">
                  <Col lg={6}>
                    <Row>
                      <Card className="mt-4">
                        <CardBody className="mt-2">
                          <h6 className="">
                            Submission No. :{" "}
                            <span className="fw-bold">
                              {report?.submissionNum}
                            </span>
                          </h6>
                          <div className="card-width-full">
                            <div className="d-flex">
                              <div className="mt-2 me-3 col">
                                <CustomInput
                                  required
                                  label={"Name"}
                                  handleBlur={formik.handleBlur}
                                  handleChange={formik.handleChange}
                                  readOnly={
                                    report?.reportStatus === "Draft"
                                      ? false
                                      : true
                                  }
                                  id={"name"}
                                  name={"name"}
                                  placeholder={"Report Name"}
                                  touched={formik.touched.name}
                                  value={formik.values.name}
                                  error={formik.errors.name}
                                />
                              </div>
                              <div className="mt-2 me-3 col">
                                <CustomSelect
                                  id={`reportTypeId`}
                                  name={`reportTypeId`}
                                  label={"Report Type"}
                                  isDisabled={
                                    report?.reportStatus === "Draft"
                                      ? false
                                      : true
                                  }
                                  options={reportTypeOption}
                                  placeholder={"Select Report Type"}
                                  required={true}
                                  setFieldTouched={formik.setFieldTouched}
                                  setFieldValue={formik.setFieldValue}
                                  touched={
                                    formik.touched.reportTypeId &&
                                    formik.touched?.reportTypeId
                                  }
                                  value={formik.values.reportTypeId}
                                  errors={
                                    formik.errors.reportTypeId &&
                                    formik.errors?.reportTypeId.value
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div className="py-1">
                            <div className="d-flex">
                              <div className="mt-2 me-3 col">
                                <CustomSelect
                                  id={`year`}
                                  name={`year`}
                                  label={"Select Year"}
                                  options={[
                                    {
                                      label: "2080",
                                      value: 2080,
                                    },
                                  ]}
                                  isDisabled={
                                    report?.reportStatus === "Draft"
                                      ? false
                                      : true
                                  }
                                  placeholder={"Select Year"}
                                  required={true}
                                  setFieldTouched={formik.setFieldTouched}
                                  setFieldValue={formik.setFieldValue}
                                  touched={
                                    formik.touched.year && formik.touched?.year
                                  }
                                  value={formik.values.year}
                                  errors={
                                    formik.errors.year &&
                                    formik.errors?.year.value
                                  }
                                />
                              </div>
                              <div className="mt-2 me-3 col">
                                <CustomSelect
                                  id={`month`}
                                  name={`month`}
                                  label={"Select Month"}
                                  options={months}
                                  isDisabled={
                                    report?.reportStatus === "Draft"
                                      ? false
                                      : true
                                  }
                                  placeholder={"Select Month"}
                                  required={true}
                                  setFieldTouched={formik.setFieldTouched}
                                  setFieldValue={formik.setFieldValue}
                                  touched={
                                    formik.touched.month &&
                                    formik.touched?.month
                                  }
                                  value={formik.values.month}
                                  errors={
                                    formik.errors.month &&
                                    formik.errors?.month.value
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Row>
                  </Col>
                  <Col lg={6} className="px-4 mt-4">
                    <Card
                      style={{
                        width: "100%",
                        height: "223px",
                        paddingTop: "60px",
                      }}
                    >
                      <Stepper
                        steps={steps}
                        activeStep={report?.reportStatus === "Draft" ? 1 : 2}
                        className=" pt-5 fs-10 mx-auto "
                        activeColor="green"
                        completeColor="green"
                      />
                    </Card>
                  </Col>
                </Row>

                <Row className="px-2">
                  <Row>
                    <Card className="p-0">
                      <CardBody className="pt-1">
                        {headings?.mainHeadings
                          // ?.slice(1, 3)
                          ?.map((item, index) => {
                            return (
                              <TableComponent
                                report={report}
                                mainHeading={item}
                                headings={item?.headings}
                                index={index}
                                formik={formik}
                                read={false}
                                disabledDraft={false}
                                isVisible={isVisible}
                                setIsVisible={setIsVisible}
                                toggleVisibility={toggleVisibility}
                              />
                              // <TableComponent
                              //   heading={
                              //     isVisible
                              //       ? item?.headingNepName
                              //       : item?.headingEngName
                              //   }
                              //   subHeadsingGroups={item?.subHeadingGroups}
                              //   index={index}
                              //   formik={formik}
                              //   report={report}
                              //   read={false}
                              //   disabledDraft={false}
                              //   isVisible={isVisible}
                              //   toggleVisibility={toggleVisibility}
                              // />
                            );
                          })}
                      </CardBody>
                    </Card>
                  </Row>
                </Row>
              </Col>
            </Row>

            <Row style={{ paddingRight: "17px" }} className="mb-4">
              <DraftButtons
                handleSaveDraft={handleSaveDraft}
                status={report?.reportStatus}
                isVisible={isVisible}
                toggleVisibility={toggleVisibility}
                resetForm={formik.resetForm}
              />
            </Row>
          </div>
        </Container>
      </form>
    </React.Fragment>
  );
};

export default DraftReport;
